import React from 'react';
import PropTypes from 'prop-types';
import ABreadCrumb from '../atoms/_atoms.breadcrumb';

export default function MIndexHero({
	type,
	title,
	img,
	alt,
}) {
	let cName;
	let bName;

	switch (type) {
		case 'left':
			cName = 'm-index-hero--left';
			break;
		case 'right':
			cName = 'm-index-hero--right';
			bName = 'a-breadcrumb--reverse';
			break;
		default:
			break;
	}

	return (
		<figure className={`m-index-hero ${cName}`}>
			<img src={img} alt={alt} />
			<figcaption>
				<ABreadCrumb currentPage={title} className={bName} />
			</figcaption>
		</figure>
	);
}

MIndexHero.propTypes = {
	type: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	img: PropTypes.string.isRequired,
	alt: PropTypes.string.isRequired,
};




// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.index-hero.js